<!-- <div class="scrollable-container">
  <div class="layout"> -->

    <router-outlet></router-outlet>
    <iot-platform-notification></iot-platform-notification>

<!-- </div>
</div> -->